import { isDefined } from "@clipboard-health/util-ts";
import { useEffect } from "react";

import { logEvent, type LogEventProps } from "../analytics/log";

export function useBeforeUnload(isEnabled: boolean, logEventProps?: LogEventProps) {
  useEffect(() => {
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isDefined(logEventProps)) {
        const { eventKey, properties } = logEventProps;
        logEvent(eventKey, properties);
      }

      if (isEnabled) {
        // This is not used in modern browsers, but kept here for
        // self documenting purposes.
        event.returnValue = "You have unsaved changes.";
        return "You have unsaved changes.";
      }

      return undefined;
    };

    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [isEnabled, logEventProps]);
}
